import React from 'react';
import PropTypes from 'prop-types';

import CreateNewOrderFormContainer from './CreateNewOrderFormContainer';

const propTypes = { params: PropTypes.object.isRequired };

const CreateOrderPage = ({ params }) => (
  <div className="row">
    <div className="col-md-12">
      <CreateNewOrderFormContainer params={params} />
    </div>
  </div>
);

CreateOrderPage.propTypes = propTypes;

export default CreateOrderPage;
